// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xl_a bhk_a bhk_x","StrollerDetailRating__muted":"xl_b bhk_fm"};